import home from '../barba-views/home';
import common from '../barba-views/common';
import agenda from '../barba-views/agenda';
import beitrageArchive from '../barba-views/beitraege-archive';
import siedlungSingle from '../barba-views/siedlung-single';
import gemeinschaftsraumSingle from '../barba-views/gemeinschaftsraum-single';
import gemeinschaftsraeume from '../barba-views/gemeinschaftsraeume';
import siedungen from '../barba-views/siedlungen';
import kontakt from '../barba-views/kontakt';
import dokumente from '../barba-views/dokumente';
import solarstrom from '../barba-views/solarstrom';
import newsletter from '../barba-views/newsletter';
import ratgeber from '../barba-views/ratgeber';
import barba from '@barba/core';
import {
  objAssignPolyfill,
  arrayIncludesPolyfill,
  arrayFindPolyfill,
} from '../util/polyfills';
import { TweenMax } from 'gsap';
import objectFitImages from 'object-fit-images';

export default {
  init() {
    // JavaScript to be fired on all pages
    // IE 11 polyfills
    objAssignPolyfill();
    arrayIncludesPolyfill();
    arrayFindPolyfill();
    objectFitImages();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    barba.init({
      debug: true,
      timeout: 5000,
      views: [
        {
          namespace: 'home',
          beforeEnter() {
            console.log('namespace home');
            common();
            home();
          },
        },
        {
          namespace: 'agenda',
          beforeEnter() {
            console.log('namespace agenda');
            common();
            agenda();
          },
        },
        {
          namespace: 'kontakt',
          beforeEnter() {
            console.log('namespace kontakt');
            common();
            kontakt();
          },
        },
        {
          namespace: 'siedlungen',
          beforeEnter() {
            console.log('namespace siedlungen');
            common();
            siedungen();
          },
        },
        {
          namespace: 'siedlungen-subarchive',
          beforeEnter() {
            console.log('namespace siedlungen-subarchive');
            common();
          },
        },
        {
          namespace: 'siedlung-single',
          beforeEnter() {
            console.log('namespace single siedlung');
            common();
            siedlungSingle();
          },
        },
        {
          namespace: 'ueber-uns',
          beforeEnter() {
            console.log('namespace ueber-uns');
            common();
          },
        },
        {
          namespace: 'gemeinschaftsraum-single',
          beforeEnter() {
            console.log('namespace single gemeinschaftsraum');
            common();
            gemeinschaftsraumSingle();
          },
        },
        {
          namespace: 'gemeinschaftsraeume',
          beforeEnter() {
            console.log('namespace gemeinschaftsraeume');
            common();
            gemeinschaftsraeume();
          },
        },
        {
          namespace: 'community',
          beforeEnter() {
            console.log('namespace ueber-uns');
            common();
          },
        },
        {
          namespace: 'ueber-uns-sub',
          beforeEnter() {
            console.log('namespace ueber-uns-sub');
            common();
          },
        },
        {
          namespace: 'team',
          beforeEnter() {
            console.log('namespace team');
            common();
          },
        },
        {
          namespace: 'beitraege',
          beforeEnter() {
            console.log('namespace beitraege archive');
            common();
            beitrageArchive();
          },
        },
        {
          namespace: 'single-beitrag',
          beforeEnter() {
            console.log('namespace beitraege single-post');
            common();
          },
        },
        {
          namespace: 'single-veranstaltungen',
          beforeEnter() {
            console.log('namespace single-veranstaltungen');
            common();
          },
        },
        {
          namespace: 'single-reparatur',
          beforeEnter() {
            console.log('namespace single-reparatur');
            common();
          },
        },
        {
          namespace: 'formular',
          beforeEnter() {
            console.log('namespace formular');
            common();
          },
        },
        {
          namespace: 'ratgeber',
          beforeEnter() {
            console.log('namespace ratgeber');
            common();
            ratgeber();
          },
        },
        {
          namespace: 'dokumente',
          beforeEnter() {
            console.log('namespace dokumente');
            common();
            dokumente();
          },
        },
        {
          namespace: 'solarstrom',
          beforeEnter() {
            console.log('namespace solarstrom');
            common();
            solarstrom();
          },
        },
        {
          namespace: 'vermietung',
          beforeEnter() {
            console.log('namespace vermietung');
            common();
          },
        },
        {
          namespace: 'error404',
          beforeEnter() {
            console.log('error404');
            common();
          },
        },
        {
          namespace: 'datenschutz',
          beforeEnter() {
            console.log('datenschutz');
            common();
          },
        },
        {
          namespace: 'impressum',
          beforeEnter() {
            console.log('impressum');
            common();
          },
        },
        {
          namespace: 'newsletter',
          beforeEnter() {
            console.log('newsletter');
            common();
            newsletter();
          },
        },
      ],
      transitions: [
        {
          name: 'standard',
          beforeLeave(data) {
            // retrieve the current page url
            console.log('standard leave');
            return new Promise((resolve) => {
              TweenMax.fromTo(
                data.current.container,
                0.35,
                { opacity: 1 },
                {
                  opacity: 0,
                  onComplete: function () {
                    $('html, body').scrollTop(0);
                    resolve();
                  },
                }
              );
            });
          },
          enter(data) {
            console.log('entering');
          },
          beforeEnter(data) {
            console.log(data.next.container);
            let headerHeight = $('header.banner').innerHeight();

            if ($(data.next.container).hasClass('y-shifted')) {
              $(data.next.container).css(
                'padding-top',
                headerHeight - headerHeight / 2
              );
            } else {
              $(data.next.container).css('padding-top', headerHeight);
            }
          },
          afterEnter(data) {
            // retrieve the next page url (short syntax)
            console.log('standard enter');


              // $(data.next.container).find('script').each(function (i, script) {
              //   var $script = $(script);
              //   $.ajax({
              //     url: $script.attr('src'),
              //     cache: true,
              //     dataType: 'script',
              //     success: function () {
              //       $script.trigger('load');
              //       console.log('scripts loaded');
              //     },
              //   });
              // });
            

            // let js = data.next.container.querySelectorAll('main script');
            // if(js != null){
            //         js.forEach((item) => {
            //             console.log(js)
            //             eval(item.innerHTML);
            //         });
            // }

            return new Promise((resolve) => {

              


              TweenMax.fromTo(
                data.next.container,
                0.35,
                { opacity: 0 },
                {
                  opacity: 1,
                  onComplete: function () {
                    resolve();
                  },
                }
              );
            });
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/init.js